<template >
  <head>
    <meta charset="UTF-8">
  </head>
<div v-if="!isMobile"  class="background">

  <el-dialog
      v-model="mobileDialog.saveTemplateDialog"
      title="保存模板"
      width="30%"
  >
    <div style="width: 100%;font-size: 14px;color: red" >不输入模板名则视为覆盖当前模板,</div>
    <div style="width: 100%;font-size: 14px;color: red" >新增模板请输入名字</div>

    <div style="height: 120px;width: 100%;display: flex;justify-content: center;align-items: center;margin-top: 2%"  >
      <el-input v-model="productDetail.templateName" style="width:80%;height:40px;;font-size: 16px" placeholder="模板名"  ></el-input>

    </div>
    <div style="height: 120px;width: 100%;display: flex;justify-content:center;align-items: center">
      <el-button style="width: 50%" type="primary"  @click="this.saveTemplate">保存</el-button>
    </div>
  </el-dialog>


  <el-dialog
      v-model="mobileDialog.deleteTemplateDialog"
      title="删除模板"
      width="30%"
  >
    <div style="width: 100%;font-size: 16px;color: red" >你要删除此模板吗？</div>

    <div style="height: 120px;width: 100%;display: flex;justify-content:center;align-items: center">
      <el-button style="width: 50%" type="primary"  @click="this.deleteTemplate">删除</el-button>
    </div>
  </el-dialog>


  <el-select
      v-model="productDetail.id"
      placeholder="Select"
      size="large"
      style="width: 240px;margin-top: 5%"
      @change="getProductDetail"
  >
    <el-option
        v-for="item in productDetail.productDetailTemplateInfoList"
        :key="item.id"
        :label="item.productDetailTemplateName"
        :value="item.id"
    />
  </el-select>

  <el-dialog
      v-model="dialogVisible.dialogVisible"
      title="页面二维码"
      width="30%"
  >
    <div style="height: 500px;width: 100%;display: flex;justify-content: center;align-items: center"  >
      <el-image  :src="this.dialogVisible.photoSrc" :preview-src-list="putPhotoToArray(this.dialogVisible.photoSrc)" style="width: 400px;height: 400px"  :initial-index="0"
                 alt="" fit="cover"/>


    </div>
    <div style="height: 120px;width: 100%;display: flex;justify-content:center;align-items: center">
      <el-button style="width: 50%" type="primary"  @click="dialogVisible.dialogVisible = false">取消</el-button>
    </div>
  </el-dialog>


  <div class="header">
<!--    公司名称-->
    <el-input v-model="productDetail.companyName" style="width:30%;height:75px;margin-left: auto;margin-right: 3%;margin-top: 70px;font-size: 32px"  :style="{ '--inputColor': this.productDetail.color}" ></el-input>

  </div>



  <div style="width:100%;height:38%;display:flex;margin-top: 1%">
   <div style="height:100%;width: 30%">
     <el-upload class="leaveCarton" accept=".jpg,.jpeg,.png,.gif,.bmp" action="#"  :auto-upload="false" ref="pictureUpload" :on-change="uploadPic"
     >
         <el-image alt="" ref="showPic" fit="cover" style="height: 450px;width: 100%" :src="this.productPhoto"  v-bind:title="'上传图片'"/>


     </el-upload>
   </div>
    <div style="width:70%;height:450px">
      <div style="height: 15%;margin-top: 2%;">
        <div style="width: 60%;margin-left:  40%;height: 100%;display: flex">

          <div style="width: 25%;height: 100%;display: flex;justify-content: center;align-items: center">
            <div style="height: 100%;width: 50%">
              <img style="height: 100%" src="https://www.haranz.com:8888/assets/header-computer.png"/>
            </div>
            <div style="font-size: 24px;font-weight: bold;margin-left: 10px;width: 50%">专业</div>
          </div>

          <div style="width: 25%;height: 100%;display: flex;justify-content: center;align-items: center;margin-left: 5%">
            <div style="height: 100%;width: 50%">
              <img style="height: 100%" src="https://www.haranz.com:8888/assets/header-masonry.png"/>
            </div>
            <div style="font-size: 24px;font-weight: bold;margin-left: 10px;width: 50%">品质</div>
          </div>

          <div style="width: 25%;height: 100%;display: flex;justify-content: center;align-items: center;margin-left: 5%">
            <div style="height: 100%;width: 50%">
              <img style="height: 100%" src="https://www.haranz.com:8888/assets/header-loveicon.png"/>
            </div>
            <div style="font-size: 24px;font-weight: bold;margin-left: 10px;width: 50%">服务</div>
          </div>

        </div>

      </div>

      <div style="margin-top:1%;height: 3%;background-color: RGB(69,69,69)"></div>
        <div  :style="getBackgroundColorStyles()" style="height: 55%;display: flex;justify-content: center;align-items: center;;font-size: 80px;color: white">
          {{this.productDetail.companyName}}

        </div>


      <div style="height: 3%;background-color: RGB(69,69,69)"></div>

      <div style="height: 15%;width:100%;display: flex;align-items: center">
        <img style="height: 100%;margin-left: 45%" src="https://www.haranz.com:8888/assets/back-grey.png"/>
        <img style="height: 100%" src="https://www.haranz.com:8888/assets/back-orange.png"/>
        <div style="justify-content: center;align-items: center;display: flex;margin-left: auto;font-weight: bold;" :style="getColorStyles()">点我选择颜色</div>
        <el-color-picker title="取色器"  style="height:50%;margin-left:1%" v-model="this.productDetail.color" @change="handleColorChange" >
        </el-color-picker>
      </div>
    </div>



  </div>

  <div style="width:100%;height:10%;display: flex">
    <div style="width: 20%;height:100%;margin-left: auto;margin-top:3%;display:flex;align-items: center;justify-content:center;font-size: 48px">竭诚为您服务</div>
  </div>


  <div style="width:100%;height:8%;display: flex;margin-top: 5%">
    <div style="width: 100%;display:flex;align-items: center;justify-content:center;font-weight: bold">
      <el-input style="width: 30%;font-size: 32px;font-weight: bold" v-model="this.productDetail.productNumber"  ></el-input>
    </div>
  </div>

  <div style="width:100%;height:6%;display: flex;margin-top: 2%">
    <div style="width: 100%;display:flex;align-items: center;justify-content:center;font-weight: bold">
      <el-input style="width: 30%;font-size: 32px;font-weight: bold" v-model="this.productDetail.productSimpleInfo"  ></el-input>
    </div>
  </div>


  <div style="width: 100%;height: 65%;position:relative;margin-top: 2%">

    <div style="width: 100%;display:flex;align-items: center;justify-content:center;font-size: 48px">
      <el-input style="width: 20%;font-size: 32px;font-weight: bold" v-model="this.productDetail.modelNumberPrefix" ></el-input>
      <div style="font-weight: bold;display:flex;align-items: center;justify-content:center;width: 20%;margin-left: 1%">
        <el-input style="width: 100%;font-size: 32px;font-weight: bold" v-model="this.productDetail.modelNumber"  ></el-input>
</div>
    </div>
    <div style="width: 100%;display:flex;align-items: center;justify-content:center;font-size: 48px">
      <el-input style="width: 20%;font-size: 32px;font-weight: bold" v-model="this.productDetail.batchNumberPrefix" ></el-input>
      <div style="font-weight: bold;display:flex;align-items: center;justify-content:center;width: 20%;margin-left: 1%">
        <el-input style="width: 100%;font-size: 32px;font-weight: bold" v-model="this.productDetail.batchNumber"  ></el-input>
      </div>
      </div>
     <div style="height: 80%;display:flex;">
       <div style="width: 35%;height:100%;margin-top:3%;position: relative">
         <div style="border-radius: 50%;background-color: orange;position: absolute;height: 150px;width:150px;top: -75px;left: -75px;z-index: 999;display:flex;align-items: center;justify-content:center;color: white;font-weight: bold ">研发成果
         </div>
         <img :src="this.productDetail.certificateList[0].certificatePhoto" style="height: 55%;position: absolute;left: 0%;top: 0%"/>
         <img :src="this.productDetail.certificateList[1].certificatePhoto" style="height: 55%;position: absolute;left: 10%;top: 10%"/>
         <img :src="this.productDetail.certificateList[2].certificatePhoto" style="height: 55%;position: absolute;left: 20%;top: 20%"/>
         <img :src="this.productDetail.certificateList[3].certificatePhoto" style="height: 55%;position: absolute;left: 30%;top: 30%"/>
         <div style="font-size: 32px;width: 100%;;display:flex;align-items: center;justify-content:center;position: absolute;left: 0;bottom: 0;">发明专利</div>

       </div>
       <div style="width: 65%;height:100%;margin-top:3%;position: relative">
         <div style="height: 20%;width: 100%;display: flex">

           <div>
             <img style="height: 100%" src="https://www.haranz.com:8888/assets/warning.png"/>
           </div>

           <div style="font-size: 30px;color: red;height: 100%;display:flex;align-items: center;justify-content:center;width: 50%;margin-left: 2%;margin-top: 5%">
               <el-input type="textarea" rows="5" class="safeInfo" style="width: 100%;font-size: 30px;font-weight: bold" :style="{ '--inputColor': 'RGB(255,0,0)'}" v-model="this.productDetail.safetyTips"  ></el-input>
           </div>

         </div>

         <div style="height: 20%;width: 100%;display: flex;margin-top: 10%">
           <div style="font-size: 30px;height: 100%;display:flex;align-items: center;justify-content:center;width: 50%;margin-left: 15%;margin-top: 5%">
             <el-input type="textarea" rows="2" style="width: 100%;font-size: 30px;font-weight: bold" :style="{ '--inputColor': 'RGB(255,0,0)'}" v-model="this.productDetail.safetyTipsInfo"  ></el-input>
           </div>
         </div>


         <div style="margin-top: auto;width: 100%;height:30%;position:absolute;left: 0;bottom: 0;">
           <div  style="width: 75%;margin-left:25%;height: 33%;display:flex;align-items: center;justify-content:left;font-size: 32px">
             <img src="https://www.haranz.com:8888/assets/point.png">
             <el-upload class="leaveCarton" action="#"  :auto-upload="false" ref="fileUpload" :on-change="uploadFile"
             >
               <template #default  >
                 <el-link  type="primary"  style="font-size: 32px!important"> 检验报告(点击上传-没有可以不上传)</el-link>

               </template>
             </el-upload>
           </div>
           <div style="width: 75%;margin-left:25%;height: 33%;display:flex;align-items: center;justify-content:left;font-size: 32px">
                     <img src="https://www.haranz.com:8888/assets/point.png">地址：<el-input  style="width: 70%;font-size: 28px;font-weight: bold" v-model="this.productDetail.address"  ></el-input>
           </div>
           <div style="width: 75%;margin-left:25%;height: 33%;display:flex;align-items: center;justify-content:left;font-size: 32px">
             <img src="https://www.haranz.com:8888/assets/point.png">联系电话：<el-input  style="width: 70%;font-size: 28px;font-weight: bold" v-model="this.productDetail.phone"  ></el-input>
           </div>

         </div>
       </div>
     </div>

  </div>

  <div style="width: 100%;height: 10%;display: flex;align-items: center;justify-content: center">
    <el-input style="width: 30%"  v-model="this.adminPassWord" placeholder="请输入管理员密码（不能输入中文）" @input="onInput"></el-input>
  </div>
  <div style="width: 100%;height: 10%;">
      <el-button type="primary" style="width: 30%;margin-top: 5%" @click="submitPage()">执行</el-button>
  </div>

  <div style="width: 100%;height: 10%;">
    <el-radio-group v-model="selectButtonIndex" style="margin-top: 5%">
      <el-radio :label="1" >{{ButtonFunction[0]}}</el-radio>
      <el-radio :label="2" >{{ButtonFunction[1]}}</el-radio>
      <!--          <el-radio value="3" >{{ButtonFunction[2]}}</el-radio>-->
      <el-radio :label="3" >{{ButtonFunction[3]}}</el-radio>
    </el-radio-group>
  </div>

  <div style="width: 100%;height: 25%;;">

  </div>


</div>

  <div v-if="isMobile" class="home">

    <el-dialog
        v-model="mobileDialog.saveTemplateDialog"
        title="保存模板"
        width="80%"
    >
      <div style="width: 100%;font-size: 14px;color: red" >不输入模板名则视为覆盖当前模板,</div>
      <div style="width: 100%;font-size: 14px;color: red" >新增模板请输入名字</div>

      <div style="height: 70px;width: 100%;display: flex;justify-content: center;align-items: center;margin-top: 2%"  >
        <el-input v-model="productDetail.templateName" style="width:80%;height:40px;;font-size: 16px" placeholder="模板名"  ></el-input>

      </div>
      <div style="height: 120px;width: 100%;display: flex;justify-content:center;align-items: center">
        <el-button style="width: 50%" type="primary"  @click="this.saveTemplate">保存</el-button>
      </div>
    </el-dialog>


    <el-dialog
        v-model="mobileDialog.deleteTemplateDialog"
        title="删除模板"
        width="80%"
    >
      <div style="width: 100%;font-size: 14px;color: red" >你要删除此模板吗？</div>

      <div style="height: 120px;width: 100%;display: flex;justify-content:center;align-items: center">
        <el-button style="width: 50%" type="primary"  @click="this.deleteTemplate">删除</el-button>
      </div>
    </el-dialog>

    <div>

      <el-select
          v-model="productDetail.id"
          placeholder="Select"
          size="large"
          style="width: 240px"
          @change="getProductDetail"
      >
        <el-option
            v-for="item in productDetail.productDetailTemplateInfoList"
            :key="item.id"
            :label="item.productDetailTemplateName"
            :value="item.id"
        />
      </el-select>

    </div>

    <header class="mobileHeader">
      <!--    公司名称-->

      <h1  >
        <el-input v-model="productDetail.companyName" style="width:80%;height:40px;;font-size: 32px"  :style="{ '--inputColor': this.productDetail.color}" ></el-input>

      </h1>
    </header>

    <el-dialog
        v-model="dialogVisible.dialogVisiblePhone"
        title="页面二维码"
        width="80%"
    >
      <div style="width: 80%;display: flex;justify-content: center;align-items: center;;margin-left: 10%"  >
        <el-image  :src="this.dialogVisible.photoSrc" :preview-src-list="putPhotoToArray(this.dialogVisible.photoSrc)" style="height: 200px;"  :initial-index="0"
                   alt="" fit="cover"/>


      </div>
      <div style="height: 70px;width: 100%;display: flex;justify-content:center;align-items: center">
        <el-button style="width: 50%" type="primary"  @click="dialogVisible.dialogVisiblePhone = false">取消</el-button>
      </div>
    </el-dialog>
    <main class="content">
      <div style="width: 100%;height: 20%;display: flex;justify-content: space-around">

        <div style="width: 25%;height: 100%;display: flex;justify-content: center;align-items: center">
          <div style="height: 100%;width: 50%">
            <img style="height: 100%" src="https://www.haranz.com:8888/assets/header-computer.png"/>
          </div>
          <div style="font-size: 24px;font-weight: bold;margin-left: 10px;width: 50%">专业</div>
        </div>

        <div style="width: 25%;height: 100%;display: flex;justify-content: center;align-items: center;margin-left: 5%">
          <div style="height: 100%;width: 50%">
            <img style="height: 100%" src="https://www.haranz.com:8888/assets/header-masonry.png"/>
          </div>
          <div style="font-size: 24px;font-weight: bold;margin-left: 10px;width: 50%">品质</div>
        </div>

        <div style="width: 25%;height: 100%;display: flex;justify-content: center;align-items: center;margin-left: 5%">
          <div style="height: 100%;width: 50%">
            <img style="height: 100%" src="https://www.haranz.com:8888/assets/header-loveicon.png"/>
          </div>
          <div style="font-size: 24px;font-weight: bold;margin-left: 10px;width: 50%">服务</div>
        </div>

      </div>
      <div style="height:200px;width: 100%;margin-top: 1%;display: flex">
        <div style="width: 50%;height: 100%">
          <el-upload  accept=".jpg,.jpeg,.png,.gif,.bmp" action="#"  :auto-upload="false" ref="pictureUploadPhone" :on-change="uploadPic"
          >
            <el-image :src="this.productPhoto"    style="width: 100%;height: 200px"  :initial-index="0"
                       alt="" fit="cover"/>

          </el-upload>

        </div>

        <div style="width:50%;height:100%">

          <div style="margin-top:15%;height: 3%;background-color: RGB(69,69,69)"></div>
          <div :style="getBackgroundColorStyles()" style="height: 55%;display: flex;justify-content: center;align-items: center;;font-size: 24px;font-weight:bold;color: white">
            {{this.productDetail.companyName}}

          </div>
          <div style="height: 3%;background-color: RGB(69,69,69)"></div>

          <div style="height: 15%;width:100%;margin-top: 5%">
            <img style="width: 30%;height:100%;margin-left: 10%" src="https://www.haranz.com:8888/assets/back-grey.png"/>
            <img style="width: 30%;height: 100%;margin-left: 5%" src="https://www.haranz.com:8888/assets/back-orange.png"/>

          </div>


        </div>
      </div>


      <div style="width:100%;height:30px;margin-top:15px;display: flex">
        <div style="width: 40%;height:100%;margin-left: auto;margin-right:5%;margin-top:3%;display:flex;align-items: center;justify-content:center;font-size: 16px">竭诚为您服务</div>
      </div>

      <div style="width:100%;height:70px;margin-top:15px;display: flex;justify-content: center;align-items: center">
        <div style="font-weight: bold;display: flex;justify-content: center;align-items: center;margin-left: auto" :style="getColorStyles()">点我选择颜色</div>
        <el-color-picker title="取色器"  style="height:50%;margin-left:5%" v-model="this.productDetail.color" @change="handleColorChange" >
        </el-color-picker>
      </div>

      <div style="width:100%;height:20px;display: flex;margin-top: 30px">
        <div style="width: 100%;display:flex;align-items: center;justify-content:center;font-size: 16px;font-weight: bold">
          <el-input style="width: 60%;" v-model="this.productDetail.productNumber"  ></el-input>

        </div>

      </div>

      <div style="width:100%;height:40px;display: flex;justify-content:center;align-items:center;margin-top: 20px">
        <el-input style="width: 60%"  v-model="this.productDetail.productSimpleInfo" ></el-input>
      </div>

      <div style="width: 100%;display:flex;align-items: center;justify-content:center;font-size: 16px;margin-top: 15px">
        <el-input style="width: 30%"  v-model="this.productDetail.modelNumberPrefix" ></el-input>
        <div style="width: 40%;margin-left: 5%">
          <el-input   v-model="this.productDetail.modelNumber"  ></el-input>
        </div>
      </div>
      <div style="width: 100%;display:flex;align-items: center;justify-content:center;font-size: 16px;margin-top: 15px">
        <el-input style="width: 30%"  v-model="this.productDetail.batchNumberPrefix" ></el-input>
        <div style="width: 40%;margin-left: 5%">
          <el-input   v-model="this.productDetail.batchNumber"  ></el-input>
        </div>
      </div>

      <div style="height: 150px;width: 100%;display: flex;justify-content:center;align-items:center;margin-top: 30px">

        <div>
          <img style="height: 80%" src="https://www.haranz.com:8888/assets/warning.png"/>
        </div>

        <div style="font-size: 16px;color: red;height: 100%;display:flex;align-items: center;justify-content:center">
          <el-input type="textarea" rows="5" style="width: 100%;font-size: 16px;font-weight: bold;margin-left: 5%" :style="{ '--inputColor': 'RGB(255,0,0)'}" v-model="this.productDetail.safetyTips"  ></el-input>
        </div>


      </div>

      <div style="height: 150px;width: 100%;;display: flex;justify-content:center;align-items:center;margin-top: 20px">
        <div style="font-size: 16px;width:40%;margin-left:40%;color: red;height: 100%;display:flex;align-items: center;justify-content:center">
          <el-input type="textarea" rows="2" style="width: 100%;font-size: 16px;font-weight: bold;margin-left: 5%" :style="{ '--inputColor': 'RGB(255,0,0)'}" v-model="this.productDetail.safetyTipsInfo"  ></el-input>
        </div>
      </div>

      <div style="width: 60%;margin-left:20%;height:450px;margin-top:60px;position: relative;">
        <div style="border-radius: 50%;background-color: orange;position: absolute;height: 70px;width:70px;top: -35px;left: -35px;z-index: 999;display:flex;align-items: center;justify-content:center;color: white;font-weight: bold ">研发成果
        </div>
        <img :src="this.productDetail.certificateList[0].certificatePhoto"  style="height: 55%;position: absolute;left: 0%;top: 0%"/>
        <img :src="this.productDetail.certificateList[1].certificatePhoto" style="height: 55%;position: absolute;left: 10%;top: 10%"/>
        <img :src="this.productDetail.certificateList[2].certificatePhoto" style="height: 55%;position: absolute;left: 20%;top: 20%"/>
        <img :src="this.productDetail.certificateList[3].certificatePhoto" style="height: 55%;position: absolute;left: 30%;top: 30%"/>
        <div style="font-size: 16px;width: 100%;;display:flex;align-items: center;justify-content:center;position: absolute;left: 0;bottom: 0;">发明专利</div>

      </div>


      <div style="margin-top: 40px;width: 100%;height:200px;">
        <div  style="width: 70%;margin-left:15%;height: 40px;display:flex;align-items: center;justify-content:left;font-size: 16px">
          <img src="https://www.haranz.com:8888/assets/point.png">
          <el-upload class="leaveCarton" action="#"  :auto-upload="false" ref="fileUploadPhone" :on-change="uploadFile"
          >
            <template #default  >
              <el-link  type="primary"  style="font-size: 16px!important"> 检验报告(点击上传-没有可以不上传)</el-link>

            </template>
          </el-upload>
        </div>
        <div style="width: 70%;margin-left:15%;height: 40px;display:flex;align-items: center;justify-content:left;font-size: 16px;margin-top: 20px">
          <img src="https://www.haranz.com:8888/assets/point.png"> 地址：<el-input style="width: 60%"  v-model="this.productDetail.address" ></el-input>
        </div>
        <div style="width: 70%;margin-left:15%;height: 40px;display:flex;align-items: center;justify-content:left;font-size: 16px;margin-top: 20px;margin-bottom: 20px">
          <img src="https://www.haranz.com:8888/assets/point.png">联系电话：<el-input style="width: 50%"  v-model="this.productDetail.phone" ></el-input>
        </div>

      </div>

      <div style="margin-top: 10px;width: 100%;height:70px;">
        <el-input style="width: 50%"  v-model="this.adminPassWord" placeholder="请输入管理员密码（不能输入中文）" @input="onInput" ></el-input>
      </div>

      <div style="margin-top: 10px;width: 100%;height:120px;">
        <el-button type="primary" style="width: 50%;margin-top: 5%" @click="submitPage()">执行

        </el-button>

        <el-radio-group v-model="selectButtonIndex" style="margin-top: 5%">
          <el-radio :label="1" >{{ButtonFunction[0]}}</el-radio>
          <el-radio :label="2" >{{ButtonFunction[1]}}</el-radio>
<!--          <el-radio value="3" >{{ButtonFunction[2]}}</el-radio>-->
          <el-radio :label="3" >{{ButtonFunction[3]}}</el-radio>

        </el-radio-group>
      </div>

    </main>
    <footer class="footer">
      <p>{{this.productDetail.companyName}}</p>
    </footer>
  </div>

</template>

<script>
import {FolderAdd} from "@element-plus/icons";
import { ElMessage } from 'element-plus'
let ws = null
import { ref } from 'vue'

const value = ref('')
export default {
  inject: ['reload'],
  name: "LightChatHome",
  components:{
    FolderAdd
  },
  data:function (){
    return{
      productDetail:{
        id:-1,
        companyName:"",
        shortCompanyName:"",
        modelNumberPrefix:"",
        modelNumber:"",
        batchNumberPrefix:"",
        batchNumber:"",
        safetyTips:"",
        address:"",
        phone:"",
        productPhoto:"",
        productNumber:"",
        pdfUrl:null,
        color:"",
        safetyInputcolor:"red",
        safetyTipsInfo:"",
        productSimpleInfo:"",
        templateName:"",
        certificateList:[{
          certificatePhoto:""
        },{
          certificatePhoto:""
        },{
          certificatePhoto:""
        },{
          certificatePhoto:""
        }],

        productDetailTemplateInfoList:[{
          id:-1,
          productDetailTemplateName:"1"
        }],

      },

      selectButtonIndex: 1,

      mobileDialog:{
        saveTemplateDialog:false,
        deleteTemplateDialog:false,
      },

      ButtonFunction:["生成页面","保存模板","保存模板并生成页面","删除模板"],

      dialogVisible:{
        dialogVisible:false,
        dialogVisiblePhone:false,
        photoSrc:"",
      },


      isMobile:false,
      adminPassWord:"",
      productPhoto:""
    }
  },
  methods:{
    init(){
        this.getProductDetail()
         //this.initId()
    },
    getId(){
      let id = this.getParameterByName('id');
      this.productDetail.id = id?id:null

    },

    onInput(event) {

      const value = event;
      // 只保留非中文字符
      this.adminPassWord = value.replace(/[\u4e00-\u9fa5]/g, '');
    },

      putPhotoToArray (src){
        let temp = []
        temp.push(src)
        return temp
      },

    getColorStyles(){
      return {
        color: this.productDetail.color,
      };
    },

    getBackgroundColorStyles(){
      return {
        backgroundColor: this.productDetail.color,
      };
    },

    getProductDetail(paramId){
     let form = new FormData()
      //let id = this.getParameterByName('id');
      let id = this.productDetail.id
      if (paramId){
        id = paramId
      }

      //id = id !== -1?id:1
      form.append("id",id)
      this.$axios.post('/huaran/ProductDetailTemplate/getProductDetailTemplate',form,this.$roleUtil.fillHeader()).then(resp=>{
        if (this.$roleUtil.checkResp(resp)) {
          console.log(resp)
          this.productDetail = resp.data.data
          this.productPhoto = this.productDetail.productPhoto
          document.title = this.productDetail.companyName || "宁波华然管业有限公司";
        }
      })
    },
    checkDevice() {
      this.isMobile = window.innerWidth <= 768;
      console.log(this.isMobile)
    },

     getParameterByName(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
      const results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
      },

    uploadFile: function (file, fileList) {
      // if (this.loadingBody) {
      //   this.$elMeassage({
      //     showClose: true,
      //     message: "你有一个正在发送的文件，请耐心等待发送完成后再发送",
      //     type: 'warning',
      //   })
      //   return 0
      // }

        if (fileList.length > 1) {
          if (this.isMobile) {
          let uploadFiles = this.$refs.fileUploadPhone.uploadFiles
          uploadFiles.splice(0, 1)
        }else {
            let uploadFiles = this.$refs.fileUpload.uploadFiles
            uploadFiles.splice(0, 1)
          }
      }

    },

    uploadPic: function (file, fileList) {
      // if (this.loadingBody) {
      //   this.$elMeassage({
      //     showClose: true,
      //     message: "你有一个正在发送的文件，请耐心等待发送完成后再发送",
      //     type: 'warning',
      //   })
      //   return 0
      // }
      if (fileList.length > 1) {
        if (this.isMobile){
          let uploadFiles = this.$refs.pictureUploadPhone.uploadFiles
          uploadFiles.splice(0, 1)
        }else {
          let uploadFiles = this.$refs.pictureUpload.uploadFiles
          uploadFiles.splice(0, 1)
        }

      }

      this.loadImage()
    },
    loadImage:function() {
      let files ;
      if (this.isMobile){
        files = this.$refs.pictureUploadPhone.uploadFiles[0].raw
      }else{
        files =  this.$refs.pictureUpload.uploadFiles[0].raw
      }
      let reader = new FileReader();
      reader.readAsBinaryString(files);
      // this.optionVue.msg = "data:" + files.type + ";base64," + window.btoa(reader.result)
      let _this = this
      reader.onload = e => {
        // let result = document.getElementById("cutPhoto")
        _this.productPhoto = "data:" + files.type + ";base64," + window.btoa(e.target.result)
        // result.setAttribute('src', src);
      };
    },

    generatePage(){

    },

    handleColorChange(value) {
      this.productDetail.color = this.hexToRgb(value);
    },
    hexToRgb(hex) {
      let r = 0, g = 0, b = 0;
      // 3 digits
      if (hex.length === 4) {
        r = parseInt(hex[1] + hex[1], 16);
        g = parseInt(hex[2] + hex[2], 16);
        b = parseInt(hex[3] + hex[3], 16);
      }
      // 6 digits
      else if (hex.length === 7) {
        r = parseInt(hex[1] + hex[2], 16);
        g = parseInt(hex[3] + hex[4], 16);
        b = parseInt(hex[5] + hex[6], 16);
      }
      return `RGB(${r}, ${g}, ${b})`;
    },

    changeInputColor () {
      var r = Math.floor(Math.random() * 256)
      var g = Math.floor(Math.random() * 256)
      var b = Math.floor(Math.random() * 256)
      // 设置随机色
      var color = '#' + r.toString(16) + g.toString(16) + b.toString(16)
      this.colorVal = color
    },

    submitPage(){
     if (this.selectButtonIndex === 1){
       this.savePage()
     }else if (this.selectButtonIndex === 2){
       this.productDetail.templateName = ""
       this.mobileDialog.saveTemplateDialog = true
       // this.saveTemplate()
      }else if (this.selectButtonIndex === 3){
       this.mobileDialog.deleteTemplateDialog = true
     }


    },

    savePage(){
      let files = null;
      let pic = null;

      // let id = this.getParameterByName('id');
      //
      // if (id){
      //   this.productDetail.id = id
      // }else{
      //   this.productDetail.id = null;
      // }

      console.log(this.productDetail.id)
      if (this.isMobile){
        if(this.$refs.fileUploadPhone.uploadFiles[0]){
          files = this.$refs.fileUploadPhone.uploadFiles[0].raw;
        }

        if (this.$refs.pictureUploadPhone.uploadFiles[0]){
          pic = this.$refs.pictureUploadPhone.uploadFiles[0].raw;
        }
      }else {

        if(this.$refs.fileUpload.uploadFiles[0]){
          files = this.$refs.fileUpload.uploadFiles[0].raw;
        }

        if (this.$refs.pictureUpload.uploadFiles[0]){
          pic = this.$refs.pictureUpload.uploadFiles[0].raw;
        }
      }



      let form = new FormData()

      form.append("files",files)
      form.append("pic",pic)
      form.append("productDetail",JSON.stringify(this.productDetail))

      this.$axios.post('/huaran/productDetail/addProduct',form,{
        headers: {'adminPassword': this.adminPassWord}
      }).then(resp=>{
        if (this.$roleUtil.checkResp(resp)) {
          if (this.isMobile) {
            this.dialogVisible.dialogVisiblePhone = true
          }else{
            this.dialogVisible.dialogVisible = true

          }
          this.dialogVisible.photoSrc = resp.data.data
          console.log(resp)
        }
      })
    },

    deleteTemplate(){
      let form = new FormData()

      form.append("id",this.productDetail.id)

      this.$axios.post('/huaran/ProductDetailTemplate/deleteTemplate',form,{
        headers: {'adminPassword': this.adminPassWord}
      }).then(resp=>{
        if (this.$roleUtil.checkResp(resp)) {
          this.$roleUtil.showMsg("删除模板成功")
          window.location.reload();
          // if (this.isMobile) {
          //   this.mobileDialog.saveTemplateDialog = false
          //   this.getProductDetail(resp.data,data)
          // }else{
          //   this.dialogVisible.dialogVisible = true
          //
          // }

        }
      })
    },

    saveTemplate(){
      let files = null;
      let pic = null;

      // let id = this.getParameterByName('id');
      //
      // if (id){
      //   this.productDetail.id = id
      // }else{
      //   this.productDetail.id = null;
      // }

      console.log(this.productDetail.id)
      if (this.isMobile){
        if(this.$refs.fileUploadPhone.uploadFiles[0]){
          files = this.$refs.fileUploadPhone.uploadFiles[0].raw;
        }

        if (this.$refs.pictureUploadPhone.uploadFiles[0]){
          pic = this.$refs.pictureUploadPhone.uploadFiles[0].raw;
        }
      }else {

        if(this.$refs.fileUpload.uploadFiles[0]){
          files = this.$refs.fileUpload.uploadFiles[0].raw;
        }

        if (this.$refs.pictureUpload.uploadFiles[0]){
          pic = this.$refs.pictureUpload.uploadFiles[0].raw;
        }
      }



      let form = new FormData()

      form.append("files",files)
      form.append("pic",pic)
      form.append("productTemplate",JSON.stringify(this.productDetail))

      this.$axios.post('/huaran/ProductDetailTemplate/addTemplate',form,{
        headers: {'adminPassword': this.adminPassWord}
      }).then(resp=>{
        if (this.$roleUtil.checkResp(resp)) {
          this.$roleUtil.showMsg("保存模板成功")
          window.location.reload();
          // if (this.isMobile) {
          //   this.mobileDialog.saveTemplateDialog = false
          //   this.getProductDetail(resp.data,data)
          // }else{
          //   this.dialogVisible.dialogVisible = true
          //
          // }

        }
      })
    },




  },


  mounted() {
    //if(this.$roleUtil.checkLoginStatus(this)) {
      this.init()
    this.checkDevice()
    window.addEventListener('resize', this.checkDevice);

   // }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  },


}
</script>

<style scoped>
.header{
  width: 100%;

}
.background{
  padding: 0;
  width: 60%;
  height: 100%;
  margin-left: 20%;
  position: relative;
}
.home {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
  text-align: center;
  padding: 20px;
}
.mobileHeader {

  color: white;
  padding: 15px 0;
}
.content {
  flex: 1;
  padding: 20px 0;
}
.footer {
  background-color: #f1f1f1;
  padding: 10px 0;
}

/deep/ .el-input__inner {
  color: var(--inputColor);
}

/deep/ .el-textarea__inner {
  color: var(--inputColor);
}

.safeInfo .el-input__inner {
  color: red; /* 修改为需要的颜色 */
}

@media (max-width: 600px) {
  .home {
    padding: 10px;
  }
  .header, .footer {
    padding: 10px 0;
  }
}
</style>
